import React from 'react';
import { Box, Flex, Tooltip } from '@chakra-ui/react';
import { LayeredDonut, LayeredDonutRing } from './LayeredDonut';

interface BrokerHealthScoreGaugeProps {
  score?: number;
  rag?: string; // kept for API compat
}

export const BrokerHealthScoreGauge: React.FC<BrokerHealthScoreGaugeProps> = () => {
  // Coming soon — mirrors P2P donut structure but fully grayscale
  const rings: LayeredDonutRing[] = [
    { value: 100, color: '#FFFFFF', isDecorative: true },  // outer white ring (same as P2P)
    { value: 100, color: '#E5E7EB' },                       // light gray
    { value: 100, color: '#D1D5DB' },                       // mid-light gray
    { value: 100, color: '#9CA3AF' },                       // medium gray
  ];

  return (
    <Flex direction="column" align="center" w="100%" maxW={{ base: '160px', hxl: '200px' }}>
      <Tooltip label="Coming Soon" hasArrow placement="top">
        <Box w="100%" cursor="default">
          <LayeredDonut
            rings={rings}
            centerLabel="—"
            hollowPercent="42%"
            centerFontSize="3xl"
          />
        </Box>
      </Tooltip>
    </Flex>
  );
};
